import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';

const useStyles = (clickable) =>
  makeStyles(() =>
    createStyles({
      wrapper: {
        position: 'relative',
        padding: '24px',
        background: clickable ? colorsPalette.blackSecondary : colorsPalette.violetAnalyticsCard,
        boxShadow: `0px 3px 5px ${colorsPalette.black}`,
        borderRadius: 5,
        cursor: clickable && 'pointer',
        transition: 'background 0.3s',
        '&:hover': {
          background: clickable ? colorsPalette.violetAnalyticsCard : colorsPalette.blackSecondary,
        },
      },
    }),
  );

export default useStyles;
